
import React from 'react';
import { Button } from "@/components/ui/button";
import { Loader2, Check } from 'lucide-react';
import { Badge } from "@/components/ui/badge";
import { Bot } from 'lucide-react';

interface ChatTemplateChangeProps {
  description: string;
  isGenerating: boolean;
  onConfirm: () => void;
  onCancel: () => void;
}

const ChatTemplateChange: React.FC<ChatTemplateChangeProps> = ({
  description,
  isGenerating,
  onConfirm,
  onCancel
}) => {
  return (
    <div className="mb-6 flex flex-col items-start">
      <div className="flex items-center mb-1.5">
        <Badge variant="default" className="bg-gray-800 text-white text-xs flex items-center gap-1.5 py-1">
          <Bot className="h-3 w-3" />
          <span>Assistent</span>
        </Badge>
      </div>
      
      <div className="rounded-lg px-4 py-3 max-w-[85%] break-words bg-gray-800 text-white border border-gray-700/30">
        <div className="space-y-3">
          <p className="text-jade font-medium">Änderungsvorschlag für Template</p>
          
          <div className="whitespace-pre-wrap text-sm">
            {description}
          </div>
          
          <div className="flex items-center space-x-2 pt-2">
            <Button
              variant="outline"
              size="sm"
              onClick={onConfirm}
              disabled={isGenerating}
              className="bg-jade hover:bg-jade/80 text-white border-none flex items-center gap-2"
            >
              {isGenerating ? (
                <>
                  <Loader2 className="h-4 w-4 animate-spin" />
                  Wird angewendet...
                </>
              ) : (
                <>
                  <Check className="h-4 w-4" />
                  Änderungen anwenden
                </>
              )}
            </Button>
            
            <Button
              variant="outline"
              size="sm"
              onClick={onCancel}
              disabled={isGenerating}
              className="bg-transparent hover:bg-gray-700 text-white border-gray-600"
            >
              Abbrechen
            </Button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ChatTemplateChange;
